module.exports = __webpack_public_path__ + "img/2.5a31f663.png";